import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityPayerValidationModalTemplate({ facilityPayerValidationModalStore, t }) {
    const {
        modalData,
        isRunning,
        hasRun,
        isValid,
        errors,
        syncAndValidate
    } = facilityPayerValidationModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>
                    {modalData.corporateChanged
                        ? t('FACILITY.PAYERS_NEED_ATTENTION')
                        : t('FACILITY.EDIT.PAYER_VALIDATION.TITLE')}
                </h3>
            </div>
            <div className="modal__body">
                <p className='u-mar--bottom--sml type--color--secondary'>
                    {t('FACILITY.EDIT.PAYER_VALIDATION.INTRO')} <strong>{modalData.facilityName}</strong>:
                </p>
                <ol className='u-mar--bottom--med type--color--secondary'>
                    <li className='u-mar--bottom--tny'>{t('FACILITY.EDIT.PAYER_VALIDATION.STEP_CREATE')}</li>
                    <li>
                        {t('FACILITY.EDIT.PAYER_VALIDATION.STEP_RENAME_1')}
                        <strong> (MM/DD/YYYY-MM/DD/YYYY)</strong>
                        {t('FACILITY.EDIT.PAYER_VALIDATION.STEP_RENAME_2')} <strong>(-MM/DD/YYYY)</strong>
                        {t('FACILITY.EDIT.PAYER_VALIDATION.STEP_RENAME_3')}
                    </li>
                </ol>

                {isRunning &&
                    <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                        <div className="u-flex--space-between">
                            <div>
                                <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                {t('FACILITY.EDIT.PAYER_VALIDATION.IN_PROGRESS')}
                            </div>
                        </div>
                    </div>}

                {!isRunning && hasRun && isValid &&
                    <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                        <div className="u-flex--space-between">
                            <div>
                                <i className="u-icon u-icon--sml u-icon--active u-mar--right--sml"></i>
                                {t('FACILITY.EDIT.PAYER_VALIDATION.VALID')}
                            </div>
                        </div>
                    </div>}

                {!isRunning && hasRun && !isValid &&
                    <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                        <div>
                            <div className='u-mar--bottom--tny'>
                                <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                {t('FACILITY.EDIT.PAYER_VALIDATION.ERRORS')}
                            </div>
                            <ul>
                                {errors.map((error, index) => <li key={index}>{error}</li>)}
                            </ul>
                        </div>
                    </div>}
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label='FACILITY.EDIT.PAYER_VALIDATION.SUBMIT'
                    onClick={() => syncAndValidate()}
                    disabled={isRunning}
                />
            </div>
        </section>
    )
}

FacilityPayerValidationModalTemplate.propTypes = {
    facilityPayerValidationModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityPayerValidationModalTemplate);
